
const TokenKey = 'loginToken'
const CodeKey = 'code'
const LevelKey = 'level'
export function getToken() {
  return localStorage.getItem(TokenKey);
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}
export function getCode() {
  return localStorage.getItem(CodeKey);
}

export function setCode(token) {
  return localStorage.setItem(CodeKey, token)
}

export function removeCode() {
  return localStorage.removeItem(CodeKey)
}

export function getLevel() {
  return localStorage.getItem(LevelKey);
}

export function setLevel(token) {
  return localStorage.setItem(LevelKey, token)
}

export function removeLevel() {
  return localStorage.removeItem(LevelKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js